import { render, staticRenderFns } from "./InactivityDetection.vue?vue&type=template&id=6fdf9338"
import script from "./InactivityDetection.vue?vue&type=script&lang=js"
export * from "./InactivityDetection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports